import React from "react";
import { useSectionForm } from "./hooks/useSectionForm";
import { getDressingAppearanceAsync, patchDressingAppearanceAsync } from "../../../../app/patientSlice";
import ConfirmationModal from "../../../secondary/ConfirmationModal/ConfirmationModal";
import { DressingAppearanceEditMode } from "./DressingAppearanceEditMode";
import { DressingAppearanceViewMode } from "./DressingAppearanceViewMode";

const CONFIRMATION_MESSAGE = "All progress in this section will be lost. Are you sure want to cancel?";

const dataSelector = (state) => state.patient.dressingAppearance;
const listSelector = (state) => state.patient.dressingappearanceListoptions;

const hasDataFn = (resp, dataKey) => resp?.[dataKey] != null;

const buildPayload = (formData, base) => ({
  ...base,
  dressingAppearance: formData.dressinghStatus,
});

export const DressingAppearance = ({ interventionId, assessmentDetails }) => {
  const hook = useSectionForm({
    interventionId,
    dataSelector,
    listSelector,
    fetchAction: getDressingAppearanceAsync,
    patchAction: patchDressingAppearanceAsync,
    optionType: "dressingappearance",
    dataKey: "dressingAppearance",
    hasDataFn,
    buildPayload,
    callViewModeOnMount: true,
  });

  return (
    <>
      {hook.confirmationModal && (
        <ConfirmationModal message={CONFIRMATION_MESSAGE} onConfirm={hook.yesConfirmationModalClick} onClose={hook.confirmationClose} />
      )}

      <div>
        {hook.editable ? (
          <DressingAppearanceEditMode
            assessmentDetails={assessmentDetails}
            setFormChangesConfirm={hook.setFormChangesConfirm}
            handleSubmit={hook.handleSubmit}
            doSubmit={hook.doSubmit}
            listResp={hook.listResp}
            resp={hook.resp}
            register={hook.register}
            onCancelClick={hook.handleCancelClick}
            hideButtons={hook.hideButtons}
          />
        ) : (
          <DressingAppearanceViewMode resp={hook.resp} assessmentDetails={assessmentDetails} hideButtons={hook.hideButtons} onEdit={hook.editMode} />
        )}
      </div>
    </>
  );
};
